import { UserStore, NewUserStore, ChangeUserStore, DropDownUserStore } from './users-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new UserStore());
  storeBuilder.addRepository(new NewUserStore());
  storeBuilder.addRepository(new ChangeUserStore());
  storeBuilder.addRepository(new DropDownUserStore());
}
